import type { ReactNode } from "react";

type ResponsiveDataTableProps = {
  children: ReactNode;
  className?: string;
};

const ResponsiveDataTable = ({ children, className = "" }: ResponsiveDataTableProps) => (
  <div className={`table-responsive ${className}`.trim()}>{children}</div>
);

export default ResponsiveDataTable;
